import { tz as momentTz } from 'moment-timezone';
import { MedelyDateTime } from '@medely/date-time-tools';
import { pluralize } from '@mp/utils';

type JobTimeProps = {
  currentStartsTime?: string | null;
  approvedClockIn?: string | null;
  currentEndsTime?: string | null;
  approvedClockOut?: string | null;
  timezoneLookup?: string | null;
  guaranteedMinimumHours?: number | null;
  status?: string | null;
};

export const jobTime = ({
  approvedClockIn,
  approvedClockOut,
  currentStartsTime,
  currentEndsTime,
  timezoneLookup,
  guaranteedMinimumHours,
  status,
}: JobTimeProps): string | null => {
  if (!currentStartsTime || !currentEndsTime) {
    return null;
  }

  const timezone = timezoneLookup || momentTz.guess();
  const startsTime = approvedClockIn || currentStartsTime;
  const endsTime = approvedClockOut || currentEndsTime;
  const start = new MedelyDateTime(startsTime, { tz: timezone });
  const end = new MedelyDateTime(endsTime, { tz: timezone });

  const hoursDiff = start.difference(end, 'hours').toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const hours =
    status === 'canceled_with_fee'
      ? guaranteedMinimumHours
      : Math.max(guaranteedMinimumHours ?? 0, +hoursDiff);

  return `${start.militaryTime}-${end.militaryTime} (${pluralize(hours ?? 0, 'hr')})`;
};

export const jobDate = (startDate?: string | null, timezone?: string | null): string | null => {
  if (!startDate) {
    return null;
  }

  const date = new MedelyDateTime(startDate, {
    tz: timezone ?? 'system',
  }).format('EEE MMM dd, yyyy');

  return date;
};
